import { useEffect, useState } from "react";
import { X, Download, Loader2, Camera } from "lucide-react";
import api from "@/lib/api";

export default function EvidenceGallery({ photos, title, onClose }) {
  const [urls, setUrls] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrls = [];
    Promise.all(
      photos.map((id) =>
        api.get(`/files/${id}`, { responseType: "blob" })
          .then((res) => {
            const u = URL.createObjectURL(res.data);
            objectUrls.push(u);
            return [id, u];
          })
          .catch(() => [id, null])
      )
    ).then((pairs) => {
      setUrls(Object.fromEntries(pairs));
      setLoading(false);
    });
    return () => { objectUrls.forEach((u) => URL.revokeObjectURL(u)); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos]);

  const download = (url, i) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = `evidencia_${i + 1}_${(title || "").replace(/[^a-zA-Z0-9-_ ]/g, "").slice(0, 30)}.jpg`;
    a.click();
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: "rgba(5,8,18,0.92)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="evidence-gallery-modal"
    >
      <div className="w-full max-w-3xl panel-strong overflow-hidden flex flex-col" style={{ maxHeight: "92vh" }} onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-3 border-b flex items-center justify-between gap-3" style={{ borderColor: "var(--border)" }}>
          <div className="min-w-0">
            <div className="label-mono flex items-center gap-1.5"><Camera className="w-3.5 h-3.5" /> EVIDENCIAS DE COMPRA · {photos.length}</div>
            {title && <div className="text-sm font-semibold text-slate-100 truncate">{title}</div>}
          </div>
          <button onClick={onClose} data-testid="evidence-close-btn" className="btn-ghost p-1.5 rounded-sm shrink-0"><X className="w-4 h-4" /></button>
        </div>
        <div className="flex-1 overflow-auto p-4 space-y-4" style={{ background: "#05070f" }}>
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="w-8 h-8 animate-spin" style={{ color: "var(--cyan)" }} />
            </div>
          ) : (
            photos.map((id, i) => (
              <div key={id} className="relative">
                <div className="flex items-center justify-between mb-1">
                  <span className="label-mono text-[10px]">FOTO {i + 1} / {photos.length}</span>
                  {urls[id] && (
                    <button onClick={() => download(urls[id], i)} data-testid={`evidence-download-${i}`} className="btn-ghost px-2 py-1 rounded-sm text-[10px] uppercase tracking-widest flex items-center gap-1" style={{ color: "var(--cyan)" }}>
                      <Download className="w-3 h-3" /> Descargar
                    </button>
                  )}
                </div>
                {urls[id] ? (
                  <img src={urls[id]} alt={`Evidencia ${i + 1}`} className="w-full object-contain rounded-sm" style={{ maxHeight: "70vh", border: "1px solid var(--border)" }} />
                ) : (
                  <div className="text-xs text-slate-500 py-6 text-center">No se pudo cargar esta foto</div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
